<template>
    <div>
        <div v-if="!initialized && busy"><i class="icon-spinner2 spinner"></i></div>
        <div v-else-if="product">
            <ValidationObserver ref="pdfinfoform">
                <form @submit.prevent="saveProduct">
                    <div class="row">
                        <div class="col-lg-6">
                            <ValidationProvider vid="ProdDescPDF" name="Beskrivning" rules="" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Beskrivning</label>
                                    <elastic-textarea class="form-control" v-model="product.ProdDescPDF" style="min-height: 300px;"></elastic-textarea>
                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <div class="row">
                                <div class="col-lg-6">
                                    <ValidationProvider vid="ProdIconPDF" name="Leverantörslogo" rules="" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Leverantörslogo</label>
                                            <mediabank-selector
                                                v-model="product.ProdIconPDF"
                                                style="min-height: 200px;"
                                                btn-class="btn-sm btn-secondary"
                                                btn-text="Bläddra"
                                                btn-icon="icon-image2"
                                                :category-id="1012"
                                                category-locked
                                                thumbnail
                                                upload
                                            ></mediabank-selector>
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </ValidationObserver>

            <div class="d-flex justify-content-end">
                <limitless-button ref="btnsavepdfinfo" type="button" @click="saveProduct" :busy="busy" icon="icon-floppy-disk">SPARA</limitless-button>
            </div>
        </div>
        <div v-else class="text-danger">Kunde ej hämta data...</div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import MediabankSelector from '@components/MediabankSelector';
import ElasticTextarea from '@components/ElasticTextarea';
import getError from '@services/ErrorHelper';

export default {
    name: 'ProductEditorPdfInfo',
    components: {
        ElasticTextarea,
        MediabankSelector,
        LimitlessButton,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        initialized: false,
        busy: true,
        product: null,
    }),
    mounted() {
        this.getProduct();
    },
    methods: {
        getProduct() {
            apiClient.get('/vue/products/' + this.id + '/pdfinfo')
                .then((response) => {
                    this.product = response.data.product;
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy = false;
                });
        },
        async saveProduct() {
            const isValid = await this.$refs.pdfinfoform.validate();
            if (isValid) {
                this.busy = true;
                await apiClient.post('/vue/products/' + this.id + '/pdfinfo', this.product)
                    .then((response) => {
                        if (response.data.product) {
                            this.product = response.data.product;
                        }
                        this.$refs.btnsavepdfinfo.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.priceform.setErrors(parsederror);
                        }
                        this.$refs.btnsavepdfinfo.triggerFailed();
                    })
                    .finally(() => {
                        this.busy = false;
                    });
            }
        },
    },
};

</script>
